/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package coreui.theme

val uaStringResources = StringResources(
    yes = "Так",
    no = "Ні",
    dropDownMenuNotSelected = "Не вибрано",

    unexpectedErrorException = "Сталася невідома помилка. Зверніться до адміністратора системи для її вирішення.",
    authenticationException = "Помилка автентифікації, Ви ввели невірне ім'я користувача або пароль.",
    networkException = "Виникла проблема з підключенням до мережі. Будь ласка, перевірте Ваше Інтернет-з'єднання та спробуйте ще раз.",
    timeoutException = "Ваш запит перевищив час очікування. Будь ласка, перевірте Інтернет-з'єднання та спробуйте ще раз.",
    newPasswordRequiredChallengeFailed = "Час зміни пароля вичерпано. Вам необхідно увійти в обліковий запис ще раз.",
    formIsNotValidException = "Форма не дійсна.",
    noChangesException = "Зміни на цю дату відсутні.",

    passwordIsNotInvalid = "Пароль повинен мати довжину не менше 8 символів і містити принаймні одну велику літеру та одну цифру.",

    loginTitle = "Вхід",
    loginUsernameFieldLabel = "Ім'я користувача",
    loginPasswordFieldLabel = "Пароль",
    loginLogInButton = "Увійти",

    changePasswordTitle = "Вигадайте новий пароль",
    changePasswordPasswordFieldLabel = "Новий пароль",
    changePasswordChangePasswordButton = "Зберегти",
    changePasswordLogIn = "Увійти",
    changePasswordInAccount = "в обліковий запис.",
    changePasswordShowPassword = "Показати пароль",

    navigationChanges = "Зміни",
    navigationSchedule = "Розклад",
    navigationDisciplines = "Циклові комісії",
    navigationClassrooms = "Аудиторії",
    navigationCourses = "Курси",
    navigationSubjects = "Предмети",
    navigationGroups = "Групи",
    navigationTeachers = "Викладачі",
    navigationUsers = "Користувачі",
    navigationOther = "Інше",

    tablesShowAccessKeyTitle = "Код доступу",
    tablesShowAccessKeyExpiresAt = "Дійсний до {1}.",
    tablesShowAccessKeyClose = "Скасувати",
    tablesShowAccessKeyErrorLoading = "Помилка завантаження.",
    tablesShowAccessKeyRetry = "Повторити",

    tablesShowBellScheduleTitle = "Розклад дзвінків",
    tablesShowBellScheduleTextFieldTitle = "Розклад дзвінків",
    tablesShowBellScheduleSave = "Зберегти",
    tablesShowBellScheduleCancel = "Скасувати",
    tablesShowBellScheduleErrorLoading = "Помилка завантаження.",
    tablesShowBellScheduleRetry = "Повторити",

    tablesShowWorkingSaturdaysTitle = "Робочі суботи",
    tablesShowWorkingSaturdaysTextFieldTitle = "Робочі суботи",
    tablesShowWorkingSaturdaysSave = "Зберегти",
    tablesShowWorkingSaturdaysCancel = "Скасувати",
    tablesShowWorkingSaturdaysErrorLoading = "Помилка завантаження.",
    tablesShowWorkingSaturdaysRetry = "Повторити",

    tableDialogDeleteTitle = "Видалення",
    tableDialogEditTitle = "Редагування",
    tableRecordsNotFound = "Записів не знайдено.",
    tableAdd = "Додати",
    tableDelete = "Видалити",
    tableDeleteRowsWarning = "Ви збираєтесь видалити {1} запис(ів). Це призведе до видалення пов'язаних записів.",
    tableDeleteAllRowsWarning = "Ви збираєтесь видалити усі записи. Це призведе до видалення пов'язаних записів.",
    tableDeleteRowsConfirm = "Підтвердити",
    tableDeleteRowsCancel = "Скасувати",
    tableManageItemDialogSave = "Зберегти",
    tableManageItemDialogCancel = "Скасувати",

    classroomsName = "Назва",
    classroomsSearchLabel = "Пошук за назвою",

    coursesNumber = "Номер",
    coursesSearchLabel = "Пошук за номером",

    disciplinesName = "Назва",
    disciplinesSearchLabel = "Пошук за назвою",

    subjectsName = "Назва",
    subjectsSearchLabel = "Пошук за назвою",

    teachersFirstName = "Ім'я",
    teachersLastName = "Прізвище",
    teacherMiddleName = "По батькові",
    teachersDiscipline = "Циклова комісія",
    teachersIsHeadTeacher = "Голова ЦК",
    teachersSearchLabel = "Пошук за ім'ям",
    teachersFilterByDisciplineLabel = "Циклова комісія",

    groupsNumber = "Номер",
    groupsCourseNumber = "Курс",
    groupsSearchLabel = "Пошук за номером",
    groupsFilterByCourseLabel = "Курс",

    usersId = "Ідентифікатор",
    usersUser = "Користувач",
    usersGroup = "група",
    usersSearchLabel = "Пошук за ідентифікатором",

    scheduleGroupNumber = "Група",
    scheduleClassroomName = "Аудиторія",
    scheduleTeacher = "Викладач",
    scheduleSubject = "Предмет",
    scheduleEventName = "Захід",
    scheduleSubjectOrEventName = "Предмет/захід",
    scheduleLessonNumber = "Заняття",
    scheduleDayNumber = "День",
    scheduleWeekAlternation = "Чергування",
    scheduleFilterByGroupLabel = "Група",
    scheduleFilterByTeacherLabel = "Викладач",
    scheduleFilterByDayNumber = "День",
    scheduleFilterByWeekAlternation = "Чергування",
    scheduleAddSubject = "Додати заняття",
    scheduleLessons = "Заняття",

    changesGroupNumber = "Група",
    changesClassroomName = "Аудиторія",
    changesTeacher = "Викладач",
    changesSubject = "Предмет",
    changesEventName = "Захід",
    changesSubjectOrEventName = "Предмет/захід",
    changesLessonNumber = "Заняття",
    changesDayNumber = "День",
    changesWeekAlternation = "Чергування",
    changesFilterByGroupLabel = "Група",
    changesFilterByTeacherLabel = "Викладач",
    changesDate = "Дата",
    changesFilterByWeekAlternation = "Чергування",
    changesAddSubject = "Додати заняття",
    changesLessons = "Заняття",
    createChangesGroupIsNotSelected = "Групу не вибрано.",

    dayNumberAll = "Всі",
    monday = "Понеділок",
    tuesday = "Вівторок",
    wednesday = "Середа",
    thursday = "Четвер",
    friday = "П'ятниця",
    saturday = "Субота",
    sunday = "Неділя",

    weekAlternationAll = "Всі",
    weekAlternationBoth = "Завжди",
    weekAlternationNumerator = "Чисельник",
    weekAlternationDenominator = "Знаменник",
)